// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\np[data-v-1ca9e2a8] {\n  font-size: 12px;\n}\nbutton[data-v-1ca9e2a8]:last-child {\n  margin-left: 12px;\n}\n.comment-label[data-v-1ca9e2a8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 2px;\n}\n.request-review__textarea[data-v-1ca9e2a8] {\n  min-height: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
